/**
 * Badge "Reserved" / "On Auction" + sostituzione del pulsante "Add to cart"
 * con un contatto rapido WhatsApp, per la griglia prodotti di italmineral.com.
 *
 * Priorità: Reserved > Sold Out > On Auction.
 * - Reserved: nasconde Add to cart (e l'eventuale badge Sold Out nativo), mostra WhatsApp.
 * - On Auction (solo se NON è anche sold out): nasconde Add to cart, mostra WhatsApp.
 * Il pulsante WhatsApp compare dentro l'immagine, in basso, solo al passaggio del mouse
 * (stesso comportamento e stessa area di "Add to cart"); su mobile resta sempre visibile.
 *
 * Gestisce DUE possibili formati di card, perché la griglia a volte è renderizzata dal tema
 * (card .m-product-card, al caricamento iniziale senza filtri) e a volte da Globo Smart Product
 * Filter & Search (card .spf-product-card__inner, dopo un filtro/ordinamento/ricerca). Un
 * MutationObserver per ciascun contenitore griglia trovato in pagina (#gf-products sulla
 * pagina Shop, #CollectionProductGrid sulla pagina di ricerca nativa, dove Globo non interviene
 * mai quindi le card restano sempre in formato .m-product-card) intercetta ogni nuovo render.
 *
 * I tag prodotto non sono nel markup: si leggono da /products/{handle}.js (endpoint pubblico
 * Shopify, stesso dominio, nessun problema di CORS), con una cache per prodotto.
 *
 * Installazione: assets/custom-badges.js, incluso in layout/theme.liquid prima di </body>:
 *   <script src="{{ 'custom-badges.js' | asset_url }}" defer></script>
 */
(function () {
  "use strict";

  // Contenitori griglia che possono ospitare le card prodotto: la pagina Shop
  // (#gf-products, dove Globo rimpiazza le card dopo il caricamento) e la
  // pagina di ricerca nativa del tema (#CollectionProductGrid, card sempre
  // native — Globo non la tocca mai, quindi qui serve processarle comunque).
  var GRID_SELECTORS = ["#gf-products", "#CollectionProductGrid"];
  var PROCESSED_ATTR = "data-custom-badge-checked";

  // ---- Configurazione contatti ---------------------------------------------------
  var WHATSAPP_NUMBER = "393338266283"; // +39 333 826 6283, senza + e senza spazi
  var CATAWIKI_URL = "https://www.catawiki.com/it/u/16653967-italmineral";
  // ----------------------------------------------------------------------------------

  var CARD_CONFIGS = [
    {
      type: "globo",
      cardSelector: ".spf-product-card__inner",
      linkSelector: 'a.spf-product-card__image-wrapper[href*="/products/"]',
      addToCartSelector: ".spf-product__form-btn-addtocart",
      soldOutSelector: ".spf-product__label-soldout",
      multipleAddToCart: false,
      anchorSelector: null, // usa la card stessa (contiene solo immagine + azioni), per l'overlay desktop
      // La card ha altezza fissa e overflow:hidden (è il riquadro immagine): su mobile il
      // pulsante va inserito FUORI, come fratello successivo, per non finire tagliato/sovrapposto.
      mobileInsert: function (card, row) {
        var parent = card.parentElement;
        if (parent) parent.insertBefore(row, card.nextSibling);
        else card.appendChild(row);
      }
    },
    {
      type: "minimog",
      cardSelector: ".m-product-card",
      linkSelector: 'a.m-product-card__name[href*="/products/"], a.m-product-card__link[href*="/products/"]',
      addToCartSelector: "product-form",
      soldOutSelector: ".m-product-tag--soldout",
      multipleAddToCart: true,
      anchorSelector: ".m-product-card__media",
      // Su mobile: subito dopo la foto, prima di titolo/prezzo. (Il content-footer del tema
      // è nascosto di default in alcuni layout, quindi non va usato o il pulsante sparirebbe.)
      mobileInsert: function (card, row) {
        var media = card.querySelector(".m-product-card__media");
        if (media && media.parentElement) {
          media.parentElement.insertBefore(row, media.nextSibling);
        } else {
          card.appendChild(row);
        }
      }
    }
  ];

  var productCache = new Map(); // handle -> Promise<{tags, title}>

  function getHandle(card, linkSelector) {
    var link = card.querySelector(linkSelector);
    if (!link) return null;
    try {
      var url = new URL(link.getAttribute("href"), window.location.origin);
      var parts = url.pathname.split("/").filter(Boolean);
      var idx = parts.indexOf("products");
      return idx > -1 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  function fetchProductSingle(handle) {
    var promise = fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        return { tags: Array.isArray(data.tags) ? data.tags : [], title: data.title || "" };
      })
      .catch(function () {
        return { tags: [], title: "" };
      });
    return promise;
  }


  // Velocita': invece di una richiesta /products/<handle>.js per OGNI card (40-80 per pagina),
  // si scaricano UNA volta sola gli elenchi dei prodotti con tag "Reserved" e "On Auction"
  // (template collection.im-tags.liquid) e si mettono in cache per 5 minuti nella sessione.
  // Se l'elenco non e' disponibile si torna al vecchio metodo per singolo prodotto.
  var BULK_KEY = "im_badge_tags_v1";
  var BULK_TTL = 300000;
  var bulkPromise = null;
  function loadBulk() {
    if (bulkPromise) return bulkPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(BULK_KEY) || "null");
      if (c && c.h && Date.now() - c.ts < BULK_TTL) {
        bulkPromise = Promise.resolve(c.h);
        return bulkPromise;
      }
    } catch (e) {}
    function getList(slug, tag) {
      return fetch("/collections/all/" + slug + "?view=im-tags", { credentials: "same-origin" })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.json();
        })
        .then(function (d) {
          return { tag: tag, h: (d && d.h) || {} };
        });
    }
    bulkPromise = Promise.all([getList("reserved", "Reserved"), getList("on-auction", "On Auction")])
      .then(function (lists) {
        var map = {};
        lists.forEach(function (l) {
          Object.keys(l.h).forEach(function (k) {
            if (!map[k]) map[k] = { t: [], n: l.h[k] };
            map[k].t.push(l.tag);
          });
        });
        try {
          sessionStorage.setItem(BULK_KEY, JSON.stringify({ ts: Date.now(), h: map }));
        } catch (e) {}
        return map;
      })
      .catch(function () {
        return null;
      });
    return bulkPromise;
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    var promise = loadBulk().then(function (map) {
      if (!map) return fetchProductSingle(handle);
      var p = map[handle];
      return p ? { tags: p.t, title: p.n || "" } : { tags: [], title: "" };
    });
    productCache.set(handle, promise);
    return promise;
  }

  function isSoldOutVisible(card, selector) {
    if (!selector) return false;
    var el = card.querySelector(selector);
    if (!el) return false;
    if (el.style && el.style.display === "none") return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden";
  }

  function buildBadge(className, label) {
    var span = document.createElement("span");
    span.className = "custom-product-badge " + className;
    span.textContent = label;
    return span;
  }

  function buildWhatsappUrl(message) {
    return "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(message);
  }

  var WHATSAPP_ICON_SVG =
    '<svg viewBox="0 0 448 512" width="15" height="15" fill="currentColor" aria-hidden="true">' +
    '<path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>' +
    "</svg>";

  function buildCtaRow(buttons) {
    var row = document.createElement("div");
    row.className = "custom-contact-row";
    buttons.forEach(function (b) {
      var a = document.createElement("a");
      a.className = "custom-contact-btn " + b.className;
      a.href = b.href;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.innerHTML = (b.icon ? b.icon : "") + "<span>" + b.label + "</span>";
      // Evita che il click attivi anche il link della card sottostante.
      a.addEventListener("click", function (e) {
        e.stopPropagation();
      });
      row.appendChild(a);
    });
    return row;
  }

  function hideAddToCart(card, config) {
    if (config.multipleAddToCart) {
      card.querySelectorAll(config.addToCartSelector).forEach(function (el) {
        el.style.display = "none";
      });
    } else {
      var el = card.querySelector(config.addToCartSelector);
      if (el) el.style.display = "none";
    }
  }

  function ensureRelative(el) {
    if (el && window.getComputedStyle(el).position === "static") {
      el.style.position = "relative";
    }
  }

  function isTouchDevice() {
    return !!(window.matchMedia && window.matchMedia("(hover: none)").matches);
  }

  function placeCtaRow(card, config, anchor, row) {
    if (isTouchDevice()) {
      row.classList.add("custom-contact-row--mobile");
      config.mobileInsert(card, row);
    } else {
      anchor.appendChild(row);
    }
  }

  function processCard(card, config) {
    if (card.hasAttribute(PROCESSED_ATTR)) return;
    card.setAttribute(PROCESSED_ATTR, "1");

    var handle = getHandle(card, config.linkSelector);
    if (!handle) return;

    fetchProduct(handle).then(function (product) {
      var tags = product.tags;
      var hasReserved = tags.indexOf("Reserved") > -1;
      var hasAuction = tags.indexOf("On Auction") > -1;
      var soldOut = isSoldOutVisible(card, config.soldOutSelector);

      if (!hasReserved && !(hasAuction && !soldOut)) return; // niente da fare per questa card

      var productUrl = window.location.origin + "/products/" + handle;
      var title = product.title || "";

      var anchor = config.anchorSelector ? card.querySelector(config.anchorSelector) : card;
      if (!anchor) anchor = card;
      ensureRelative(anchor);

      if (hasReserved) {
        var soldOutEl = card.querySelector(config.soldOutSelector);
        if (soldOutEl) soldOutEl.style.display = "none";

        anchor.appendChild(buildBadge("custom-product-badge--reserved", "Reserved"));
        hideAddToCart(card, config);

        var waMsgReserved =
          'Hi, I\'m interested in this reserved item: "' + title + '" - ' + productUrl;
        placeCtaRow(
          card,
          config,
          anchor,
          buildCtaRow([
            { className: "custom-contact-btn--whatsapp", href: buildWhatsappUrl(waMsgReserved), label: "WhatsApp", icon: WHATSAPP_ICON_SVG }
          ])
        );
        return;
      }

      if (hasAuction && !soldOut) {
        anchor.appendChild(buildBadge("custom-product-badge--auction", "On Auction"));
        hideAddToCart(card, config);

        var waMsgAuction =
          'Hi, I\'m interested in this auction item: "' + title + '" - ' + productUrl;
        placeCtaRow(
          card,
          config,
          anchor,
          buildCtaRow([
            { className: "custom-contact-btn--whatsapp", href: buildWhatsappUrl(waMsgAuction), label: "WhatsApp", icon: WHATSAPP_ICON_SVG },
            { className: "custom-contact-btn--catawiki", href: CATAWIKI_URL, label: "Auctions" }
          ])
        );
      }
    });
  }

  function processAll(root) {
    var scope = root || document;
    CARD_CONFIGS.forEach(function (config) {
      scope.querySelectorAll(config.cardSelector).forEach(function (card) {
        processCard(card, config);
      });
    });
  }

  function watchGrid(grid) {
    processAll(grid);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          CARD_CONFIGS.forEach(function (config) {
            if (node.matches && node.matches(config.cardSelector)) {
              processCard(node, config);
            } else if (node.querySelectorAll) {
              node.querySelectorAll(config.cardSelector).forEach(function (c) {
                processCard(c, config);
              });
            }
          });
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function init(attemptsLeft) {
    if (attemptsLeft === undefined) attemptsLeft = 30; // ~9s di tentativi, poi la pagina non ha nessuna griglia prodotto

    var grids = GRID_SELECTORS
      .map(function (sel) {
        return document.querySelector(sel);
      })
      .filter(Boolean);

    if (!grids.length) {
      if (attemptsLeft > 0) window.setTimeout(function () { init(attemptsLeft - 1); }, 300);
      return;
    }

    grids.forEach(watchGrid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
